import Select from '../select/select.vue'
export default {
  data() {
    return {

    }
  },
  methods: {
    //点击课程跳转到课程详情
    toSection(id, is_project) {
      // alert(is_project);
      this.$toClass(id, is_project);
    },
  },
  props: {
    course: Object
  },
  components:{
    Select
  }
}